import React, {PropTypes,Component}  from 'react';
import './SmoothButton.less';
import tools from '../../utils/tools';
import {autobind} from 'core-decorators';

const preventEvent = (event) => {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
};

class SmoothButton extends Component {

  constructor(props, context) {
     super(props, context);
     const {isChoosed = false} = this.props;
     this.state = {
       isChoosed: isChoosed
     }
  }

   @autobind
   handleClick(event) {
     const {choose,title,value} = this.props;
     preventEvent(event);
     let newChooseState = !this.state.isChoosed;
     this.setState({
       isChoosed: newChooseState
     });
     choose(event,title,value,newChooseState);
   }

   componentWillReceiveProps(nextProps){
     const {isChoosed = false} = nextProps;
     this.state = {
       isChoosed: isChoosed
     }
   }

  render (){
    const {isChoosed = false} = this.props;
    var classString = 'button';
    const {title} = this.props;
    if (this.state.isChoosed) {
        classString = classString + ' active';
    } else {
        classString = classString + ' ';
    }
    return (
        <span className={classString} onClick={this.handleClick}>{title}</span>
    );
  }

}
export default SmoothButton;
